import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./ProductosAgotadosInactivos.css";
const API = process.env.REACT_APP_API_URL


export default function ProductosAgotadosInactivos() {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const navigate = useNavigate();
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);


  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch( API + "/user/refresh",{
         method:"POST",
          credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        window.location.reload();
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const cargarProductos = async () => {
    try {
      const response = await fetch( API + "/productos/traerTodosProductos", {
      });
      const data = await response.json();
      const productosFormateados = (data.content || []).map(p => ({
        ...p,
        estadoTemporal: p.estadoProducto 
      }));
      setProductos(productosFormateados);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarProductos();
  }, [token]);

  const eliminarProducto = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar este producto?")) return;
    let response = await fetch(`${API}/productos/EliminarProducto/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` }
    });

    if(response.status === 403 && await renovarToken())return;
    cargarProductos();
  };

  const ActualizarEstado = async (id, nuevoEstado) => {
    try {
      let response = await fetch(`${API}/productos/ActualizarEstadoProducto/${id}/${nuevoEstado}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if(response.status === 403 && await renovarToken())return;
      alert("Estado actualizado ✅");
      cargarProductos();
    } catch (error) {
      alert("Error al actualizar");
    }
  };

  return (
    <div className="layout-container-admin">
      {/* HEADER CON BOTÓN VOLVER */}
      <header className="admin-header">
        <div className="container header-flex">
          <button onClick={() => navigate(-1)} className="btn-back">
            <span className="arrow">←</span> Volver
          </button>
          <h2 className="section-title">Gestión de Inventario</h2>
        </div>
      </header>

      <main className="container products-section">
        <div className="productos-grid-admin">
          {!loading ? (
            productos.map(p => (
              <div className={`producto-card-admin ${p.estadoProducto.toLowerCase()}`} key={p.id}>
                <div className="card-img-admin">
                  <img
                    src={`${API}${p.imagenesURLs?.[0]}`}
                    alt={p.nombre}
                    onError={(e) => e.target.src = 'https://via.placeholder.com/300?text=Sin+Imagen'}
                  />
                  <span className={`status-badge-admin ${p.estadoProducto.toLowerCase()}`}>
                    {p.estadoProducto}
                  </span>
                </div>
                
                <div className="card-body-admin">
                  <h4>{p.nombre}</h4>
                  <p className="card-price-admin">
                    {new Intl.NumberFormat("es-CO", {
                      style: "currency",
                      currency: "COP",
                      minimumFractionDigits: 0
                    }).format(p.precio)}
                  </p>
                  
                  <NavLink to={`/verProducto/${p.id}`} className="btn-detail-admin">Ver detalle</NavLink>

                  {user?.rol === "ROLE_ADMIN" && (
                    <div className="admin-controls">
                      <select
                        className="select-status-admin"
                        value={p.estadoTemporal}
                        onChange={(e) => {
                          const val = e.target.value;
                          setProductos(prev => prev.map(prod => 
                            prod.id === p.id ? { ...prod, estadoTemporal: val } : prod
                          ));
                        }}
                      >
                        <option value="ACTIVO">ACTIVO</option>
                        <option value="AGOTADO">AGOTADO</option>
                        <option value="INACTIVO">INACTIVO</option>
                      </select>

                      <div className="btns-row-admin">
                        <button className="btn-act edit" onClick={() => navigate(`/EditarProducto/${p.id}`)}>✏️</button>
                        <button className="btn-act delete" onClick={() => eliminarProducto(p.id)}>🗑️</button>
                        <button className="btn-act save" onClick={() => ActualizarEstado(p.id, p.estadoTemporal)}>💾</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="loader">Cargando inventario...</div>
          )}
        </div>
      </main>

      <footer className="footer-admin">
        <p>© 2026 Mundo Shop · Panel de Administración</p>
      </footer>
    </div>
  );
}